import ColorSwatch from "../../../../src/components/ColorSwatch";
import ColorGrid from "../../../../src/components/ColorGrid";
import styles from "../../../../src/pages/interior-architecture/color/color.module.scss";
import * as React from 'react';
export default {
  ColorSwatch,
  ColorGrid,
  styles,
  React
};